import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { InsightType } from 'utils/entities';
import { PriceHistoryHeading } from 'components/widget/prices/section/styled';

export const TableHeader = styled(Text)`
  ${({ theme }) => `
    font-weight: bold;
    margin: ${theme.spacing(3)} ${theme.spacing(3)} 0 0;
    color: ${theme.colors.insights[InsightType.Prices]};

    > svg {
      margin: 0 ${theme.isRTL ? '' : `-${theme.spacing(0.25)}`} ${theme.spacing(1)} ${theme.isRTL ? `-${theme.spacing(0.25)}` : ''};

      > path {
        fill: ${theme.colors.insights[InsightType.Prices]};
      }
    }
  `}
`;

export const PricesTableTitle = styled(PriceHistoryHeading)`
  font-weight: bold;
  padding-bottom: 0;
`;
